module.exports = __webpack_public_path__ + "static/media/sparkle.958bb88a.svg";